import React from "react";
import PropTypes from "prop-types";
import { Dispatcher } from "../../../flux";
import { Isvg, Spinner } from "../../../components";

export default class BookSearch extends React.Component {
  constructor(props) {
    super(props);
    const state = {
      query: "",
      results: [],
      total: 0,
      focusIndex: 0,
      searching: false,
      hasSearched: false
    };
    this.state = Object.assign(state, this.props.savedState);
  }

  componentDidMount() {
    Dispatcher.bindOnce(
      Dispatcher.BOOK_SNIPPET_READY,
      () => this.state.query && this.search(this.state.query)
    );
    this.searchInput.focus();
  }

  search(query) {
    this.setState({
      query,
      total: 0,
      searching: query.length > 0,
      timeout: false
    });
    const searchInSnippet = () => {
      const snippet = this.props.book.viewer.Snippet;
      snippet.waldoSearch(query, this.props.cfi, response => {
        if (response && response.code === 200 && response.data) {
          const { results } = response.data;
          const focusIndex = this.state.focusIndex || response.data.focusIndex;
          const total = (results && results.length) || 0;
          if (focusIndex >= 0) {
            this.props.book.viewer.Book.focusTerm(results[focusIndex]);
          }
          this.setState({
            results,
            focusIndex,
            total,
            searching: false,
            hasSearched: true
          });
        } else if (response && response.code === 504) {
          this.setState({ searching: false, hasSearched: true, timeout: true });
        }
      });
    };
    Fraction.Helpers.delayTimeout(
      searchInSnippet.bind(this),
      2500,
      "reading-snippet-search"
    );
  }

  nextResult() {
    let { focusIndex, total, results } = this.state;
    focusIndex = focusIndex + 2 > total ? 0 : focusIndex + 1;
    this.setState({ focusIndex });
    this.props.book.viewer.Book.focusTerm(results[focusIndex]);
  }

  prevResult() {
    let { focusIndex, total, results } = this.state;
    focusIndex = focusIndex - 1 < 0 ? total - 1 : focusIndex - 1;
    this.setState({ focusIndex });
    this.props.book.viewer.Book.focusTerm(results[focusIndex]);
  }

  openFullBook() {
    this.props.minimize(
      {
        "book-search": {
          query: this.state.query,
          focusIndex: this.state.focusIndex
        }
      },
      () =>
        Dispatcher.emit(Dispatcher.SHOW_PANEL, "search", {
          query: this.state.query
        })
    );
  }

  clearField() {
    this.setState({
      query: "",
      results: [],
      total: 0,
      focusIndex: 0,
      searching: false,
      hasSearched: false
    });
    $("#searchBox").val(null);
  }

  renderSearchSummary() {
    var nextSearchResults = "";
    var prevSearchResults = "";
    if (this.state.results.length <= 1) {
      prevSearchResults = "disabled";
      nextSearchResults = "disabled";
    } else if (this.state.focusIndex === 0) {
      prevSearchResults = "disabled";
    } else if (
      this.state.results.length > 0 &&
      this.state.focusIndex === this.state.total - 1
    ) {
      nextSearchResults = "disabled";
    }

    if (
      this.state.query &&
      this.state.hasSearched &&
      !this.state.searching &&
      !this.state.timeout
    ) {
      return (
        <div className="search-nav">
          <div className="nav-actions">
            <button
              className={"noButton arrow-button " + prevSearchResults}
              onClick={this.prevResult.bind(this)}
              disabled={prevSearchResults}
            >
              <Isvg src="img/search_previous.svg" />
            </button>
            <button
              className={"noButton arrow-button next " + nextSearchResults}
              onClick={this.nextResult.bind(this)}
              disabled={nextSearchResults}
            >
              <Isvg src="img/search_next.svg" />
            </button>
          </div>
          <div className="results">
            {`${this.state.total > 0 ? this.state.focusIndex + 1 : 0} of ${
              this.state.total
            }`}
          </div>
        </div>
      );
    }
    if (this.state.searching) {
      return (
        <div className="search-spinner" style={{ position: "relative" }}>
          <Spinner />
        </div>
      );
    }

    if (this.state.timeout) {
      return (
        <div id="too-long-message">
          <p>{i18n.t("reader.search.too-long", { term: this.state.query })}</p>
        </div>
      );
    }
  }

  render() {
      return (
        <div
          className="search-box"
          style={this.props.highlightsOn ? { right: "400px" } : {}}
        >
          <div className="search-area">
            <span className="text-input-wrapper">
              <input
                type="text"
                id="searchBox"
                ref={input => {
                  this.searchInput = input;
                }}
                placeholder={i18n.t("base.search")}
                value={this.state.query}
                onChange={e => this.search(e.currentTarget.value)}
              />
              {!$("#searchBox").val() ? (
                <span style={{ display: "none" }}>&times;</span>
              ) : (
                <span onClick={this.clearField.bind(this)}>&times;</span>
              )}
            </span>

            {!this.state.timeout && (
              <button
                className="noButton full-book-btn"
                onClick={this.openFullBook.bind(this)}
              >
                {i18n.t("assignments.search-full-book")}
              </button>
            )}
          </div>
          {this.renderSearchSummary()}
        </div>
      );
  }
}

BookSearch.propTypes = {
  book: PropTypes.object.isRequired
};

BookSearch.defaultProps = {
  savedState: {}
};
